// extracted by mini-css-extract-plugin
export default {"container":"SingleValuation_container__q7ein","wrapper":"SingleValuation_wrapper__d0gJv"};